// Shared labels and types for admin pages (data comes from Supabase).
export type Role = "admin" | "moderator" | "owner" | "user" | "vacanty_admin" | "vakant_owner";
export type BusinessStatus = "pending" | "approved" | "rejected" | "hidden";
export type ReportStatus = "open" | "resolved" | "dismissed";
export type BusinessKind = "restaurace" | "bar" | "kavarna" | "cajovna" | "stanek" | "jidelna" | "mlecny_bar" | "food_truck" | "rychle_obcerstveni" | "bistro";

export const roleLabel: Record<Role, string> = {
  admin: "Admin",
  moderator: "Moderátor",
  owner: "Majitel",
  user: "Uživatel",
  vacanty_admin: "Admin Vacantů",
  vakant_owner: "Majitel Vacantu",
};

export const statusLabel: Record<BusinessStatus, string> = {
  pending: "Čeká na schválení",
  approved: "Schváleno",
  rejected: "Zamítnuto",
  hidden: "Skryto",
};

export const reportStatusLabel: Record<ReportStatus, string> = {
  open: "Otevřený",
  resolved: "Vyřešený",
  dismissed: "Zamítnutý",
};

export const kindLabel: Record<BusinessKind, string> = {
  restaurace: "Restaurace",
  bar: "Bar",
  kavarna: "Kavárna",
  cajovna: "Čajovna",
  stanek: "Stánek",
  jidelna: "Jídelna",
  mlecny_bar: "Mléčný bar",
  food_truck: "Food truck",
  rychle_obcerstveni: "Fast Food",
  bistro: "Bistro",
};
